// Formats a decimal fraction as whole basis points (0.0015 -> "15").
export const formatBasisPoints = (value: number | null | undefined): string =>
    value == null ? '' : Math.round(value * 10000).toString();
